/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Data_Source_IntervalsInputs */

const en_ui_data_source_intervals = /** @type {(inputs: Ui_Data_Source_IntervalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`intervals.icu`)
};

const de_ui_data_source_intervals = /** @type {(inputs: Ui_Data_Source_IntervalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`intervals.icu`)
};

/**
* | output |
* | --- |
* | "intervals.icu" |
*
* @param {Ui_Data_Source_IntervalsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_data_source_intervals = /** @type {((inputs?: Ui_Data_Source_IntervalsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Data_Source_IntervalsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_data_source_intervals(inputs)
	return de_ui_data_source_intervals(inputs)
});